export enum AddressType {
  WAREHOUSE = 'warehouse',
  OFFICE = 'office',
  STORAGE = 'storage',
}

export type TBusinessAddress = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  addressType: AddressType;
  address: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
  phone?: string;
  contactPerson?: string;
  isActive: boolean;
  notes?: string;
};

export type TCreateBusinessAddress = Omit<
  TBusinessAddress,
  'id' | 'createdAt' | 'updatedAt'
>;

export type TUpdateBusinessAddress = Partial<TCreateBusinessAddress>;
